import { PageResult } from '@/types/we-coupons';
import { CouponInfo } from '@tencent/wphk-components-wecoupon';
import { getFavoritesCouponList, getCouponListBySpKey } from '@/api/we-coupons';
import { resolveCouponInfoArray } from '@tencent/wphk-components-wecoupon/components/mch-coupon-list/business/coupon';

/**
 * 获取收藏分类下的券列表信息
 * @returns
 */
export async function getFavoritesList(offset: number, limit: number):
Promise<PageResult<CouponInfo>> {
  const { hasNextPage, totalCount, dataList } = await getFavoritesCouponList(offset, limit);
  return {
    hasNextPage,
    totalCount,
    dataList: resolveCouponInfoArray(dataList),
  };
}

export async function getListBySpKey(key: string, offset: number, limit: number):
Promise<PageResult<CouponInfo>> {
  const { hasNextPage, totalCount, dataList } = await getCouponListBySpKey(key, offset, limit);
  return {
    hasNextPage,
    totalCount,
    dataList: resolveCouponInfoArray(dataList),
  };
};
